import { BaseService } from '../../infra/base.service'
import type { PaymentMethod } from './payment-methods'
import type { PaymentMethodsRepository } from './payment-methods.repository'

export class PaymentMethodsService extends BaseService<PaymentMethod> {
    constructor(private rep: PaymentMethodsRepository) {
        super(rep)
    }
}
